// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1NZ9i","header":"ReportDetails_header__tTXX4","title":"ReportDetails_title__DM4d1","left":"ReportDetails_left__2ZQma"};